import { TdsButton, TdsModal, TdsModalButtons } from '@trv-tds/react'

type WrappedModalProps = {
  modalTitle?: string
  size: 'small' | 'medium' | 'large'
  children: React.ReactNode
  buttonText: string
  onTdsClose: () => void
  label: string
  handleOk?: () => void
  hasCancelButton: boolean
}

const WrappedTdsModal = ({
  modalTitle,
  size,
  children,
  buttonText,
  onTdsClose,
  label,
  handleOk,
  hasCancelButton
}: WrappedModalProps) => (
  // modal component
  <TdsModal
    id='wrappedTdsModal'
    onTdsClose={onTdsClose}
    opened={true}
    dialog-title={modalTitle ?? null}
    size={size}
    aria-label={label}
  >
    {children}
    <TdsModalButtons slot="footer">
      <TdsButton
        id='okayButton'
        variant="primary"
        name='modalOkayButton'
        data-dismiss="modal"
        aria-label='continue'
        onClick={handleOk ? handleOk : onTdsClose}
      >
        {buttonText}
      </TdsButton>
      {hasCancelButton && (
        <TdsButton variant="secondary" data-dismiss="modal" onClick={onTdsClose}>
          Cancel
        </TdsButton>
      )}
    </TdsModalButtons>
  </TdsModal>
)

export { WrappedTdsModal }
